import { Icon } from './Icon';

interface ToastProps {
  message: string;
}

export function Toast({ message }: ToastProps) {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 100,
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--ink)',
        color: 'var(--paper)',
        padding: '10px 16px',
        borderRadius: 999,
        fontSize: 13,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        zIndex: 100,
        animation: 'shushPop 220ms cubic-bezier(.2,.8,.2,1)',
        boxShadow: '0 6px 24px rgba(20,19,15,0.22)',
      }}
    >
      <Icon name="check" size={14} stroke="var(--moss-soft)" sw={2.2} />
      {message}
    </div>
  );
}
